var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"voipBox"},[_c('i',{staticClass:"iconfont",class:_vm.VoIPStatusClass,on:{"click":_vm.configVoIP}}),_c('audio',{ref:"voipAudio",staticClass:"hide",attrs:{"controls":"","autoplay":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }